import {Routes} from '@angular/router';

import {CheckRolesService} from './services/check-roles.service';
import {AdminComponent, AdminData} from './admin/admin.component';
import {InboxComponent} from './inbox/inbox.component';
import {MySubticketsComponent} from './my-subtickets/my-subtickets.component';
import {TodoAssistComponent} from './todo-assist/todo-assist.component';
import {ReplyGuestComponent} from './reply-guest/reply-guest.component';
import {HomeComponent} from './home/home.component';
import {GuestRequestsComponent} from './guest-requests/guest-requests.component';
import {ReportsComponent} from './reports/reports.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {TelephoneBookComponent} from './telephone-book/telephone-book.component';
import {MyHandoverNotesComponent} from './my-handover-notes/my-handover-notes.component';
import {GuestRequestsItineraryComponent} from './guest-requests/itinerary/guest-requests-itinerary.component';
import {ReservationsComponent} from './reservations/reservations.component';
import {SubticketTypesComponent} from "./admin/subticket-types/subticket-types.component";
import {TemplatesComponent} from "./admin/templates/templates.component";
import {HotelConfigurationComponent} from "./admin/hotel-configuration/hotel-configuration.component";
import {UsersComponent} from "./admin/users/users.component";
import {VendorsComponent} from "./admin/vendors/vendors.component";
import {TreatmentRoomsComponent} from "./admin/treatment-rooms/treatment-rooms.component";
import {TicketStatusesComponent} from "./admin/ticket-statuses/ticket-statuses.component";
import {SubticketStatusesComponent} from "./admin/subticket-statuses/subticket-statuses.component";
import {PrioritiesComponent} from "./admin/priorities/priorities.component";
import {TreatmentTypesComponent} from "./admin/treatment-types/treatment-types.component";
import {TherapistsComponent} from "./admin/therapists/therapists.component";

const defaultRoute = 'home';
export const ROUTES: Routes = [
  {path: '', redirectTo: defaultRoute, pathMatch: 'full'},

  {path: 'home', component: HomeComponent},
  {path: 'inbox', component: InboxComponent},
  {path: 'my-subtickets', component: MySubticketsComponent},
  {path: 'my-handover-notes', component: MyHandoverNotesComponent},
  {path: 'telephone-book', component: TelephoneBookComponent},
  {path: 'guest-requests', component: GuestRequestsComponent},
  {path: 'guest-requests-itinerary', component: GuestRequestsItineraryComponent},
  {path: 'todo-assist', component: TodoAssistComponent},
  {path: 'reply-guest', component: ReplyGuestComponent},
  {path: 'dashboard', component: DashboardComponent},
  {path: 'reports', component: ReportsComponent},
  {path: 'reservations', component: ReservationsComponent},
  {
    path: 'admin', component: AdminComponent, resolve: {action: CheckRolesService}, children: [
      {
        path: 'subticket-types',
        component: SubticketTypesComponent,
        data: {name: 'Subticket Types', super: false} satisfies AdminData
      },
      {
        path: 'templates',
        component: TemplatesComponent,
        data: {name: 'Templates', super: false} satisfies AdminData
      },
      {
        path: 'hotel',
        component: HotelConfigurationComponent,
        data: {name: 'Hotel Configuration', super: false} satisfies AdminData
      },
      {
        path: 'users',
        component: UsersComponent,
        data: {name: 'Users', super: false} satisfies AdminData
      },
      {
        path: 'vendors',
        component: VendorsComponent,
        data: {name: 'Vendors', super: false} satisfies AdminData
      },
      {
        path: 'rooms',
        component: TreatmentRoomsComponent,
        data: {name: 'Treatment Rooms', super: false} satisfies AdminData
      },
      {
        path: 'ticket-statuses',
        component: TicketStatusesComponent,
        data: {name: 'Ticket Statuses', super: true} satisfies AdminData
      },
      {
        path: 'subticket-statuses',
        component: SubticketStatusesComponent,
        data: {name: 'Subticket Statuses', super: true} satisfies AdminData
      },
      {
        path: 'priorities',
        component: PrioritiesComponent,
        data: {name: 'Priorities', super: true} satisfies AdminData
      },
      {
        path: 'treatment-types',
        component: TreatmentTypesComponent,
        data: {name: 'Treatment Types', super: true} satisfies AdminData
      },
      {
        path: 'therapists',
        component: TherapistsComponent,
        data: {name: 'Therapists', super: true} satisfies AdminData
      },
    ]
  },
  {path: '**', redirectTo: defaultRoute},
];
